import React from 'react'
import PropTypes from 'prop-types'

/* eslint-disable */
import face from '../images/face-min.resized.png'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div
      style={{
        className: 'logo',
        zIndex: '1200',
        background: `url(${face})`,
        width: '300px',
        height: '300px',
        backgroundSize: 'cover',
      }}
    />
    <div className="content">
      <div className="inner">
        <h1>Collin Street</h1>
        <p>
          Full Stack Software Engineer currently living in the San Francisco Bay
          Area
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <a
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('intro')
            }}
          >
            About Me
          </a>
        </li>
        <li>
          <a
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('work')
            }}
          >
            Projects
          </a>
        </li>
        <li>
          <a
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            Resume
          </a>
        </li>
        <li>
          <a
            href="javascript:;"
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </a>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
